import React, { useState, useEffect, useRef } from "react";
import {
  IconSearch,
  IconFilter,
  IconDownload,
  IconUpload,
  IconList,
  IconCalendar,
  IconPlus,
  IconClock,
  IconX,
  IconChevronLeft,
  IconChevronRight,
  IconCalendarEvent,
  IconUsers,
  IconBriefcase,
  IconMapPin,
  IconCheck,
  IconChevronDown,
  IconRefresh,
  IconSettings,
  IconChecklist,
  IconTrash,
  IconEdit,
  IconDots,
} from "@tabler/icons-react";
import toast from "react-hot-toast";
import MultiSelectInput from "../../../components/common/MultiSelectInput";
import {
  fetchHrShiftTypes,
  createHrShiftType,
  fetchHrDepartments,
  createHrDepartment,
  updateHrDepartment,
  deleteHrDepartment,
  fetchHrAttendanceBreaks,
  fetchHrEmployees,
  fetchHrWorkingFrom,
  fetchHrShiftRosters,
  createHrShiftRoster,
  updateHrShiftRoster,
  deleteHrShiftRoster,
} from "../../../apis/hrApi";


// ── Shared Constants ──────────────────────────────────────────────────────────
const DAYS = [
  { day: "Sunday", date: "12", isToday: false },
  { day: "Monday", date: "13", isToday: false },
  { day: "Tuesday", date: "14", isToday: false },
  { day: "Wednesday", date: "15", isToday: false },
  { day: "Thursday", date: "16", isToday: false },
  { day: "Friday", date: "17", isToday: true },
  { day: "Saturday", date: "18", isToday: false },
];

const SHIFT_TYPES = {
  WEEK_OFF: { label: "Week Off", time: "", type: "week_off" },
  NIGHT_SHIFT: { label: "Night Shift", time: "09:00 AM - 09:00 PM", type: "night" },
  GENERAL_SHIFT: { label: "General Shift", time: "10:00 AM - 07:00 PM", type: "general" },
};

const MOCK_DEPARTMENTS = ["All Departments", "Software Development", "Human Resources", "IT & Support", "Analytics Department", "Legal & Compliance Department", "Network & Security"];
const MOCK_EMPLOYEES_LIST = ["All Employees", "Riva", "Pal", "Laksh", "Kushal", "Dhruvin", "Sandeep Patel", "Yash Koladiya", "Sanju", "Deep Vadhadiya"];
const MOCK_SHIFT_TYPES_LIST = ["All Shifts", "General Shift", "Night Shift", "Week Off", "Over Time"];

const DAY_OPTIONS = [
  { value: "MONDAY", text: "Monday" },
  { value: "TUESDAY", text: "Tuesday" },
  { value: "WEDNESDAY", text: "Wednesday" },
  { value: "THURSDAY", text: "Thursday" },
  { value: "FRIDAY", text: "Friday" },
  { value: "SATURDAY", text: "Saturday" },
  { value: "SUNDAY", text: "Sunday" },
];

const ROSTER_EMPLOYEES = [
  { id: 1, name: "Riva", department: "Legal & Compliance Department", avatar: "", shifts: ["WEEK_OFF", "NIGHT_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 2, name: "Pal", department: "Software Development", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 3, name: "Laksh", department: "Analytics Department", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 4, name: "Kushal", department: "Network & Security", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 5, name: "Dhruvin", department: "Network & Security", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 6, name: "Sandeep Patel", department: "IT & Support", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 7, name: "Yash Koladiya", department: "Human Resources", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
  { id: 8, name: "Laksh2", department: "Human Resources", avatar: "", shifts: ["WEEK_OFF", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT", "GENERAL_SHIFT"] },
];

// ── Shift Change Management Mock Data ─────────────────────────────────────────
interface ShiftChangeRecord {
  id: number;
  date: string;
  requestedType: "Extra Shift Request" | "Shift Change Request";
  employee: { name: string; department: string; avatar: string };
  requestedNewShift: string;
  extraShiftTime: string;
  processedBy: { name: string; department: string; avatar: string };
  status: "Approved" | "Pending" | "Rejected";
}

const SHIFT_CHANGE_DATA: ShiftChangeRecord[] = [
  { id: 1, date: "17-07-2026", requestedType: "Extra Shift Request",   employee: { name: "Sanju", department: "IT & Support", avatar: "" },       requestedNewShift: "General shift",  extraShiftTime: "05:30 AM - 09:00 AM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 2, date: "16-07-2026", requestedType: "Shift Change Request",  employee: { name: "Sanju", department: "IT & Support", avatar: "" },       requestedNewShift: "Night shift",    extraShiftTime: "–",                   processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 3, date: "15-07-2026", requestedType: "Extra Shift Request",   employee: { name: "Sanju", department: "IT & Support", avatar: "" },       requestedNewShift: "Morning Shift",  extraShiftTime: "08:00 AM - 09:00 AM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 4, date: "12-06-2026", requestedType: "Extra Shift Request",   employee: { name: "Laksh", department: "Analytics Department", avatar: "" },requestedNewShift: "General shift",  extraShiftTime: "06:30 PM - 08:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 5, date: "28-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Kushal", department: "Network & Security", avatar: "" }, requestedNewShift: "Night shift",    extraShiftTime: "09:00 PM - 10:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 6, date: "22-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Kushal", department: "Network & Security", avatar: "" }, requestedNewShift: "General shift",  extraShiftTime: "07:00 PM - 09:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 7, date: "25-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Pal", department: "Software Development", avatar: "" },  requestedNewShift: "Night shift",    extraShiftTime: "09:00 PM - 10:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 8, date: "25-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Kushal", department: "Network & Security", avatar: "" }, requestedNewShift: "General shift",  extraShiftTime: "07:00 PM - 09:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 9, date: "28-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Deep Vadhadiya", department: "IT & Support", avatar: "" },requestedNewShift: "General shift",  extraShiftTime: "07:00 PM - 09:00 PM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Approved" },
  { id: 10,date: "27-04-2026", requestedType: "Extra Shift Request",   employee: { name: "Sanju", department: "IT & Support", avatar: "" },        requestedNewShift: "General shift",  extraShiftTime: "07:00 AM - 09:00 AM", processedBy: { name: "Yash Koladiya", department: "Human Resources", avatar: "YK" }, status: "Pending" },
];

// ── Avatar Helper ─────────────────────────────────────────────────────────────
function AvatarBadge({ name, initials }: { name: string; initials?: string }) {
  const letters = initials ?? name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
  const colors = ["bg-amber-100 text-amber-700", "bg-blue-100 text-blue-700", "bg-emerald-100 text-emerald-700", "bg-purple-100 text-purple-700", "bg-rose-100 text-rose-700"];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold shrink-0 ${color}`}>
      {letters}
    </div>
  );
}

// ── Status Badge ──────────────────────────────────────────────────────────────
function StatusBadge({ status }: { status: string }) {
  const styles: Record<string, string> = {
    Approved: "text-emerald-600",
    Pending:  "text-amber-500",
    Rejected: "text-red-500",
  };
  const dots: Record<string, string> = {
    Approved: "bg-emerald-500",
    Pending:  "bg-amber-400",
    Rejected: "bg-red-400",
  };
  return (
    <span className={`flex items-center gap-1.5 text-xs font-semibold ${styles[status] ?? "text-gray-500"}`}>
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${dots[status] ?? "bg-gray-400"}`} />
      {status}
    </span>
  );
}

// ── Shift Cell (Roster View) ──────────────────────────────────────────────────
function ShiftCell({ shiftKey }: { shiftKey: string }) {
  const shift = SHIFT_TYPES[shiftKey as keyof typeof SHIFT_TYPES];
  if (!shift) return <td className="p-2 border-r border-b border-dashed border-gray-300"></td>;

  if (shift.type === "week_off") {
    return (
      <td className="p-2 border-r border-b border-dashed border-gray-300 min-w-[130px]">
        <div className="flex items-center justify-center h-14 rounded bg-[#EBF3FF] border border-dashed border-[#A0C4FF] text-[#5D87FF] font-semibold text-sm cursor-pointer hover:bg-blue-100 transition">
          {shift.label}
        </div>
      </td>
    );
  }

  if (shift.type === "night") {
    return (
      <td className="p-2 border-r border-b border-dashed border-gray-300 min-w-[130px]">
        <div className="flex flex-col justify-center px-3 h-14 rounded bg-[#5D6BEE] text-white cursor-pointer hover:opacity-90 transition">
          <div className="flex items-center gap-1.5 font-semibold text-sm">
            <IconClock size={14} />{shift.label}
          </div>
          <div className="text-[10px] mt-0.5 opacity-90">{shift.time}</div>
        </div>
      </td>
    );
  }

  return (
    <td className="p-2 border-r border-b border-dashed border-gray-300 min-w-[130px]">
      <div className="flex flex-col justify-center px-3 h-14 rounded bg-[#FF1919] text-white cursor-pointer hover:opacity-90 transition">
        <div className="flex items-center gap-1.5 font-semibold text-sm">
          <IconClock size={14} />{shift.label}
        </div>
        <div className="text-[10px] mt-0.5 opacity-90">{shift.time}</div>
      </div>
    </td>
  );
}

// ── Panel Type ────────────────────────────────────────────────────────────────
type PanelType = "add" | "import" | "filter" | "sc-filter" | null;
type TabType = "roster" | "shift-change";

export default function ShiftRoster() {
  const [activeTab, setActiveTab] = useState<TabType>("roster");
  const [activePanel, setActivePanel] = useState<PanelType>(null);

  // ── Roster state ──────────────────────────────────────────────────────────
  const [search, setSearch] = useState("");
  const [addMode, setAddMode] = useState<"shift" | "overtime">("shift");
  const [assignBy, setAssignBy] = useState<"date" | "multiple" | "month">("date");
  const [shiftType, setShiftType] = useState("");
  const [department, setDepartment] = useState("");
  const [employee, setEmployee] = useState("");
  const [workingFrom, setWorkingFrom] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [remark, setRemark] = useState("");
  const [sendEmail, setSendEmail] = useState(true);
  const [overwriteShift, setOverwriteShift] = useState(true);

  const [filterDept, setFilterDept] = useState("All Departments");
  const [filterEmp, setFilterEmp] = useState("All Employees");
  const [filterShift, setFilterShift] = useState("All Shifts");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");

  // ── Weekly Roster View States ──────────────────────────────────────────────
  const getSundayOfCurrentWeek = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day;
    const sunday = new Date(today.setDate(diff));
    sunday.setHours(0, 0, 0, 0);
    return sunday;
  };
  const [currentWeekStart, setCurrentWeekStart] = useState<Date>(getSundayOfCurrentWeek());
  const [rosterPage, setRosterPage] = useState(1);
  const [rosterPerPage, setRosterPerPage] = useState(10);

  // ── DB Lists ──────────────────────────────────────────────────────────────
  const [dbDepartments, setDbDepartments] = useState<any[]>([]);
  const [dbShiftTypes, setDbShiftTypes] = useState<any[]>([]);
  const [dbBreaks, setDbBreaks] = useState<any[]>([]);
  const [dbEmployees, setDbEmployees] = useState<any[]>([]);
  const [dbWorkingFrom, setDbWorkingFrom] = useState<any[]>([]);

  // ── Roster Data ───────────────────────────────────────────────────────────
  const [rosterData, setRosterData] = useState<any[]>([]);
  const [isRosterLoading, setIsRosterLoading] = useState(false);

  // ── Roster form extra fields ───────────────────────────────────────────────
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState<string[]>([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rosterStartTime, setRosterStartTime] = useState("");
  const [rosterEndTime, setRosterEndTime] = useState("");
  const [workingFromId, setWorkingFromId] = useState("");
  const [rosterDocument, setRosterDocument] = useState<File | null>(null);
  const [isRosterSubmitting, setIsRosterSubmitting] = useState(false);

  // ── Edit Roster Modal ──────────────────────────────────────────────────────
  const [showEditRosterModal, setShowEditRosterModal] = useState(false);
  const [editingRoster, setEditingRoster] = useState<any | null>(null);
  const [editRosterAssignmentType, setEditRosterAssignmentType] = useState("SHIFT");
  const [editRosterShiftTypeId, setEditRosterShiftTypeId] = useState("");
  const [editRosterWorkingFromId, setEditRosterWorkingFromId] = useState("");
  const [editRosterRemark, setEditRosterRemark] = useState("");
  const [editRosterStartTime, setEditRosterStartTime] = useState("");
  const [editRosterEndTime, setEditRosterEndTime] = useState("");
  const [isEditRosterSubmitting, setIsEditRosterSubmitting] = useState(false);

  // ── Delete Roster Modal ────────────────────────────────────────────────────
  const [showDeleteRosterModal, setShowDeleteRosterModal] = useState(false);
  const [deletingRoster, setDeletingRoster] = useState<any | null>(null);
  const [isDeleteRosterSubmitting, setIsDeleteRosterSubmitting] = useState(false);

  // ── Action menu state ─────────────────────────────────────────────────────
  const [openActionMenuId, setOpenActionMenuId] = useState<string | null>(null);
  const actionMenuRef = useRef<HTMLDivElement>(null);

  // ── Modal Visibility States ───────────────────────────────────────────────
  const [showCreateShiftModal, setShowCreateShiftModal] = useState(false);
  const [showDepartmentsModal, setShowDepartmentsModal] = useState(false);

  // ── Create Shift Form States ──────────────────────────────────────────────
  const [newShiftName, setNewShiftName] = useState("");
  const [newShiftCode, setNewShiftCode] = useState("");
  const [newBreakIds, setNewBreakIds] = useState<string[]>([]);
  const [newTotalBreakDuration, setNewTotalBreakDuration] = useState("");
  const [newStartTime, setNewStartTime] = useState("");
  const [newEndTime, setNewEndTime] = useState("");
  const [newHalfTime, setNewHalfTime] = useState("");
  const [newEarlyClockInMinutes, setNewEarlyClockInMinutes] = useState("");
  const [newLateMarkAfterMinutes, setNewLateMarkAfterMinutes] = useState("");
  const [newMaxCheckIn, setNewMaxCheckIn] = useState("");
  const [newOfficeOpenDays, setNewOfficeOpenDays] = useState<string[]>([]);
  const [newColor, setNewColor] = useState("#FF0000");
  const [newIsDefault, setNewIsDefault] = useState(false);
  const [isSubmittingShift, setIsSubmittingShift] = useState(false);

  // ── Departments Manager Modal States ──────────────────────────────────────
  const [newDeptName, setNewDeptName] = useState("");
  const [editingDeptId, setEditingDeptId] = useState<string | null>(null);
  const [isSubmittingDept, setIsSubmittingDept] = useState(false);

  // ── Load DB Data ──────────────────────────────────────────────────────────
  const loadDbData = async () => {
    try {
      const deptsRes = await fetchHrDepartments(1, 100);
      if (deptsRes.success && deptsRes.data) {
        setDbDepartments(deptsRes.data.departments || []);
      }
    } catch (err) {
      console.error("Failed to load departments:", err);
    }

    try {
      const shiftsRes = await fetchHrShiftTypes(1, 100);
      if (shiftsRes.success && shiftsRes.data) {
        let list: any[] = [];
        if (Array.isArray(shiftsRes.data)) {
          list = shiftsRes.data;
        } else if (shiftsRes.data && typeof shiftsRes.data === "object") {
          const possible = shiftsRes.data.shiftTypes || 
                           shiftsRes.data.employeeShiftTypes || 
                           shiftsRes.data.list || 
                           shiftsRes.data.data || 
                           shiftsRes.data.shiftType ||
                           shiftsRes.data.employeeShiftType ||
                           shiftsRes.data.types;
          if (Array.isArray(possible)) {
            list = possible;
          } else {
            const found = Object.values(shiftsRes.data).find(Array.isArray);
            if (found) list = found as any[];
          }
        }
        setDbShiftTypes(list);
      }
    } catch (err) {
      console.error("Failed to load shift types:", err);
    }

    try {
      const breaksRes = await fetchHrAttendanceBreaks(1, 100);
      if (breaksRes.success && breaksRes.data) {
        let list: any[] = [];
        if (Array.isArray(breaksRes.data)) {
          list = breaksRes.data;
        } else if (breaksRes.data && typeof breaksRes.data === "object") {
          const possible = breaksRes.data.attendanceBreaks || breaksRes.data.list || breaksRes.data.data || breaksRes.data.attendanceBreak;
          if (Array.isArray(possible)) {
            list = possible;
          }
        }
        setDbBreaks(list.map((b: any) => ({
          id: b.id || b._id,
          value: b.id || b._id,
          text: `${b.title} (${b.breakTimeMinutes} mins)`,
          breakTimeMinutes: b.breakTimeMinutes
        })));
      }
    } catch (err) {
      console.error("Failed to load breaks:", err);
    }

    try {
      const empRes = await fetchHrEmployees(1, 500);
      if (empRes.success && empRes.data) {
        const list = Array.isArray(empRes.data) ? empRes.data : (empRes.data.employees || []);
        setDbEmployees(list);
      }
    } catch (err) {
      console.error("Failed to load employees:", err);
    }

    try {
      const wfRes = await fetchHrWorkingFrom(1, 100);
      if (wfRes.success && wfRes.data) {
        const list = Array.isArray(wfRes.data) ? wfRes.data : (wfRes.data.workingFroms || wfRes.data.workingFrom || []);
        setDbWorkingFrom(list);
      }
    } catch (err) {
      console.error("Failed to load working from:", err);
    }
  };

  const loadRosterData = async () => {
    setIsRosterLoading(true);
    try {
      const res = await fetchHrShiftRosters(1, 200);
      if (res.success && res.data) {
        let list: any[] = [];
        if (Array.isArray(res.data)) list = res.data;
        else {
          const found = Object.values(res.data).find(Array.isArray);
          if (found) list = found as any[];
        }
        setRosterData(list);
      }
    } catch (err) {
      console.error("Failed to load roster data:", err);
    } finally {
      setIsRosterLoading(false);
    }
  };

  useEffect(() => {
    loadDbData();
    loadRosterData();
  }, []);

  // Auto-calculate Half Time
  useEffect(() => {
    if (newStartTime && newEndTime) {
      const [sh, sm] = newStartTime.split(":").map(Number);
      const [eh, em] = newEndTime.split(":").map(Number);
      let startMinutes = sh * 60 + sm;
      let endMinutes = eh * 60 + em;
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60; // Next day overlap
      }
      const halfMinutes = Math.round((startMinutes + endMinutes) / 2) % (24 * 60);
      const hh = Math.floor(halfMinutes / 60);
      const mm = halfMinutes % 60;
      setNewHalfTime(`${hh.toString().padStart(2, "0")}:${mm.toString().padStart(2, "0")}`);
    } else {
      setNewHalfTime("");
    }
  }, [newStartTime, newEndTime]);

  // Auto-calculate Break Duration
  useEffect(() => {
    let total = 0;
    newBreakIds.forEach((id) => {
      const b = dbBreaks.find((x) => x.id === id);
      if (b) {
        total += b.breakTimeMinutes || 0;
      }
    });
    setNewTotalBreakDuration(total.toString());
  }, [newBreakIds, dbBreaks]);

  // ── Create Shift Submit ───────────────────────────────────────────────────
  const handleCreateShiftSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newShiftName.trim() || !newShiftCode.trim() || !newStartTime || !newEndTime) {
      toast.error("Please fill all required fields");
      return;
    }
    setIsSubmittingShift(true);

    const formatTimeForBackend = (t: string) => {
      if (!t) return "";
      return t.split(":").length === 2 ? `${t}:00` : t;
    };

    const payload = {
      typeName: newShiftName.trim(),
      typeCode: newShiftCode.trim(),
      breakIds: newBreakIds,
      totalBreakDuration: newTotalBreakDuration ? parseInt(newTotalBreakDuration, 10) : 0,
      startTime: formatTimeForBackend(newStartTime),
      endTime: formatTimeForBackend(newEndTime),
      halfTime: formatTimeForBackend(newHalfTime),
      earlyClockInMinutes: newEarlyClockInMinutes ? parseInt(newEarlyClockInMinutes, 10) : 0,
      lateMarkAfterMinutes: newLateMarkAfterMinutes ? parseInt(newLateMarkAfterMinutes, 10) : 0,
      maxCheckIn: newMaxCheckIn ? parseInt(newMaxCheckIn, 10) : 1,
      officeOpenDays: newOfficeOpenDays,
      color: newColor,
      isDefault: newIsDefault,
      status: "ACTIVE",
    };

    try {
      const res = await createHrShiftType(payload);
      if (res.success) {
        toast.success("Shift type created successfully!");
        
        // Reload shift types
        const shiftsRes = await fetchHrShiftTypes(1, 100);
        if (shiftsRes.success && shiftsRes.data) {
          let list: any[] = [];
          if (Array.isArray(shiftsRes.data)) {
            list = shiftsRes.data;
          } else if (shiftsRes.data && typeof shiftsRes.data === "object") {
            const possible = shiftsRes.data.shiftTypes || 
                             shiftsRes.data.employeeShiftTypes || 
                             shiftsRes.data.list || 
                             shiftsRes.data.data || 
                             shiftsRes.data.shiftType ||
                             shiftsRes.data.employeeShiftType ||
                             shiftsRes.data.types;
            if (Array.isArray(possible)) {
              list = possible;
            } else {
              const found = Object.values(shiftsRes.data).find(Array.isArray);
              if (found) list = found as any[];
            }
          }
          setDbShiftTypes(list);
        }

        setShowCreateShiftModal(false);
        setNewShiftName("");
        setNewShiftCode("");
        setNewBreakIds([]);
        setNewStartTime("");
        setNewEndTime("");
        setNewEarlyClockInMinutes("");
        setNewLateMarkAfterMinutes("");
        setNewMaxCheckIn("");
        setNewOfficeOpenDays([]);
        setNewColor("#FF0000");
      } else {
        toast.error(res.message || "Failed to create shift type");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to create shift type");
    } finally {
      setIsSubmittingShift(false);
    }
  };

  // ── Departments CRUD Submissions ──────────────────────────────────────────
  const handleDepartmentSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newDeptName.trim()) {
      toast.error("Department name is required");
      return;
    }
    setIsSubmittingDept(true);

    try {
      let res;
      if (editingDeptId) {
        res = await updateHrDepartment(editingDeptId, { departmentName: newDeptName.trim() });
      } else {
        res = await createHrDepartment({ departmentName: newDeptName.trim() });
      }

      if (res.success) {
        toast.success(editingDeptId ? "Department updated successfully!" : "Department created successfully!");
        
        // Reload departments
        const deptsRes = await fetchHrDepartments(1, 100);
        if (deptsRes.success && deptsRes.data) {
          setDbDepartments(deptsRes.data.departments || []);
        }

        setNewDeptName("");
        setEditingDeptId(null);
      } else {
        toast.error(res.message || "Failed to save department");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to save department");
    } finally {
      setIsSubmittingDept(false);
    }
  };

  const handleDeleteDepartment = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this department?")) return;
    try {
      const res = await deleteHrDepartment(id);
      if (res.success) {
        toast.success("Department deleted successfully!");
        
        // Reload departments
        const deptsRes = await fetchHrDepartments(1, 100);
        if (deptsRes.success && deptsRes.data) {
          setDbDepartments(deptsRes.data.departments || []);
        }
      } else {
        toast.error(res.message || "Failed to delete department");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete department");
    }
  };


  // ── Shift Change state ────────────────────────────────────────────────────
  const [scSearch, setScSearch] = useState("");
  const [scSearchOpen, setScSearchOpen] = useState(false);
  const [scPage, setScPage] = useState(1);
  const [scPerPage, setScPerPage] = useState(10);
  const [scChecked, setScChecked] = useState<number[]>([]);

  // Shift Change filters state
  const [scFilterEmp, setScFilterEmp] = useState("All Employees");
  const [scFilterType, setScFilterType] = useState("All Types");
  const [scFilterShift, setScFilterShift] = useState("All Shifts");
  const [scFilterStatus, setScFilterStatus] = useState("All Statuses");
  const [scFilterDate, setScFilterDate] = useState("");

  const isSidebarOpen = activePanel !== null;

  // ── Weekly Navigation & Date Formatter Helpers ─────────────────────────────
  const getWeekDays = (startDate: Date) => {
    const days = [];
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    for (let i = 0; i < 7; i++) {
      const d = new Date(startDate);
      d.setDate(startDate.getDate() + i);
      const today = new Date();
      const isToday = d.getDate() === today.getDate() && 
                      d.getMonth() === today.getMonth() && 
                      d.getFullYear() === today.getFullYear();
      days.push({
        day: dayNames[i],
        date: d.getDate().toString(),
        month: d.toLocaleString("default", { month: "short" }),
        year: d.getFullYear(),
        isToday,
        fullDate: d,
      });
    }
    return days;
  };

  const formatWeekRange = (startDate: Date) => {
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    
    const startMonth = startDate.toLocaleString("default", { month: "short" });
    const startYear = startDate.getFullYear();
    const endMonth = endDate.toLocaleString("default", { month: "short" });
    const endYear = endDate.getFullYear();

    if (startYear === endYear) {
      if (startMonth === endMonth) {
        return `${startMonth} ${startDate.getDate()} – ${endDate.getDate()}, ${startYear}`;
      }
      return `${startMonth} ${startDate.getDate()} – ${endMonth} ${endDate.getDate()}, ${startYear}`;
    }
    return `${startMonth} ${startDate.getDate()}, ${startYear} – ${endMonth} ${endDate.getDate()}, ${endYear}`;
  };

  const handlePrevWeek = () => {
    setCurrentWeekStart(prev => {
      const d = new Date(prev);
      d.setDate(prev.getDate() - 7);
      return d;
    });
  };

  const handleNextWeek = () => {
    setCurrentWeekStart(prev => {
      const d = new Date(prev);
      d.setDate(prev.getDate() + 7);
      return d;
    });
  };

  const getRosterForEmployeeOnDate = (employeeId: string, date: Date) => {
    const targetStr = date.toISOString().split("T")[0]; // YYYY-MM-DD
    return rosterData.find((r: any) => {
      const rEmpId = r.employee?.id || r.employee?._id || r.employeeId;
      if (rEmpId !== employeeId) return false;

      if (r.rosterDate) {
        const dateStr = r.rosterDate.split("T")[0];
        return dateStr === targetStr;
      }
      if (r.fromDate) {
        const fromStr = r.fromDate.split("T")[0];
        const toStr = (r.toDate || r.fromDate).split("T")[0];
        return targetStr >= fromStr && targetStr <= toStr;
      }
      return false;
    });
  };

  // Filter employees for the weekly roster grid
  const rosterFilteredEmployees = dbEmployees.filter((emp: any) => {
    const name = (emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`).toLowerCase();
    const dept = (emp.department?.departmentName || emp.departmentName || "").toLowerCase();
    const q = search.toLowerCase();
    return name.includes(q) || dept.includes(q);
  });

  const rosterFiltered = rosterFilteredEmployees; // Compatibility alias
  const rosterTotalPages = Math.ceil(rosterFilteredEmployees.length / rosterPerPage);
  const rosterPageData = rosterFilteredEmployees.slice((rosterPage - 1) * rosterPerPage, rosterPage * rosterPerPage);

  const openPanel = (type: PanelType) => setActivePanel(prev => prev === type ? null : type);
  const closePanel = () => setActivePanel(null);

  const resetRosterForm = () => {
    setShiftType("");
    setSelectedEmployeeIds([]);
    setSelectedDate("");
    setFromDate("");
    setToDate("");
    setRosterStartTime("");
    setRosterEndTime("");
    setWorkingFromId("");
    setRemark("");
    setOverwriteShift(true);
    setRosterDocument(null);
    setAddMode("shift");
    setAssignBy("date");
  };

  const handleAddSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const shiftTypeObj = dbShiftTypes.find((s: any) => (s.id || s._id) === shiftType || s.typeName === shiftType);
    const shiftTypeId = shiftTypeObj ? (shiftTypeObj.id || shiftTypeObj._id) : shiftType;
    if (!shiftTypeId) { toast.error("Please select a shift type"); return; }
    if (selectedEmployeeIds.length === 0 && !employee) { toast.error("Please select at least one employee"); return; }

    setIsRosterSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("shiftTypeId", shiftTypeId);
      const empIds = selectedEmployeeIds.length > 0 ? selectedEmployeeIds : (employee ? [employee] : []);
      formData.append("employeeIds", JSON.stringify(empIds));
      formData.append("assignmentType", addMode === "overtime" ? "OVERTIME" : "SHIFT");
      formData.append("assignmentMode", assignBy === "date" ? "SINGLE" : assignBy === "multiple" ? "MULTIPLE" : "MONTH");
      if (assignBy === "date" && selectedDate) formData.append("rosterDate", selectedDate);
      if (assignBy === "multiple") {
        if (fromDate) formData.append("fromDate", fromDate);
        if (toDate) formData.append("toDate", toDate);
      }
      if (rosterStartTime) formData.append("startTime", rosterStartTime);
      if (rosterEndTime) formData.append("endTime", rosterEndTime);
      if (workingFromId) formData.append("workingFromId", workingFromId);
      formData.append("remark", remark);
      formData.append("overwriteOldShift", overwriteShift ? "true" : "false");
      if (rosterDocument) formData.append("documentUrls", rosterDocument);

      const res = await createHrShiftRoster(formData);
      if (res.success) {
        toast.success("Shift roster assigned successfully!");
        closePanel();
        resetRosterForm();
        loadRosterData();
      } else {
        toast.error(res.message || "Failed to assign shift roster");
      }
    } catch (err: any) {
      toast.error(err?.message || "Failed to assign shift roster");
    } finally {
      setIsRosterSubmitting(false);
    }
  };

  const handleEditRosterSubmit = async () => {
    if (!editingRoster) return;
    setIsEditRosterSubmitting(true);
    const loader = toast.loading("Updating roster...");
    try {
      const payload: any = {
        assignmentType: editRosterAssignmentType,
        workingFromId: editRosterWorkingFromId || undefined,
        remark: editRosterRemark,
      };
      if (editRosterAssignmentType === "SHIFT" && editRosterShiftTypeId) {
        payload.shiftTypeId = editRosterShiftTypeId;
      }
      if (editRosterAssignmentType === "OVERTIME") {
        if (editRosterStartTime) payload.startTime = editRosterStartTime;
        if (editRosterEndTime) payload.endTime = editRosterEndTime;
      }
      const res = await updateHrShiftRoster(editingRoster.id || editingRoster._id, payload);
      if (res.success) {
        toast.success("Roster updated successfully!", { id: loader });
        setShowEditRosterModal(false);
        loadRosterData();
      } else {
        toast.error(res.message || "Failed to update roster", { id: loader });
      }
    } catch (err: any) {
      toast.error(err?.message || "Failed to update roster", { id: loader });
    } finally {
      setIsEditRosterSubmitting(false);
    }
  };

  const handleDeleteRosterConfirm = async () => {
    if (!deletingRoster) return;
    setIsDeleteRosterSubmitting(true);
    const loader = toast.loading("Deleting roster...");
    try {
      const res = await deleteHrShiftRoster(deletingRoster.id || deletingRoster._id);
      if (res.success) {
        toast.success("Roster deleted successfully!", { id: loader });
        setShowDeleteRosterModal(false);
        setDeletingRoster(null);
        loadRosterData();
      } else {
        toast.error(res.message || "Failed to delete roster", { id: loader });
      }
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete roster", { id: loader });
    } finally {
      setIsDeleteRosterSubmitting(false);
    }
  };

  const handleFilterApply = () => { toast.success("Filters applied"); closePanel(); };
  const handleFilterClear = () => {
    setFilterDept("All Departments"); setFilterEmp("All Employees");
    setFilterShift("All Shifts"); setFilterMonth(""); setFilterYear("");
    toast("Filters cleared");
  };

  const handleScFilterApply = () => {
    toast.success("Shift Change filters applied");
    closePanel();
  };

  const handleScFilterClear = () => {
    setScFilterEmp("All Employees");
    setScFilterType("All Types");
    setScFilterShift("All Shifts");
    setScFilterStatus("All Statuses");
    setScFilterDate("");
    toast("Filters cleared");
  };

  const scFiltered = SHIFT_CHANGE_DATA.filter(r => {
    const matchSearch =
      r.employee.name.toLowerCase().includes(scSearch.toLowerCase()) ||
      r.requestedType.toLowerCase().includes(scSearch.toLowerCase()) ||
      r.requestedNewShift.toLowerCase().includes(scSearch.toLowerCase());
    const matchEmp = scFilterEmp === "All Employees" || r.employee.name === scFilterEmp;
    const matchType = scFilterType === "All Types" || r.requestedType === scFilterType;
    const matchShift = scFilterShift === "All Shifts" || r.requestedNewShift.toLowerCase().includes(scFilterShift.toLowerCase());
    const matchStatus = scFilterStatus === "All Statuses" || r.status === scFilterStatus;
    const matchDate = !scFilterDate || r.date === scFilterDate.split("-").reverse().join("-");
    return matchSearch && matchEmp && matchType && matchShift && matchStatus && matchDate;
  });
  const scTotalPages = Math.ceil(scFiltered.length / scPerPage);
  const scPageData = scFiltered.slice((scPage - 1) * scPerPage, scPage * scPerPage);

  const toggleScRow = (id: number) =>
    setScChecked(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const toggleAllSc = () =>
    setScChecked(scChecked.length === scPageData.length ? [] : scPageData.map(r => r.id));

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div className="w-full mx-auto mt-2 animate-in fade-in duration-300">

      {/* Tab Bar */}
      <div className="flex items-center gap-1 mb-4 border-b border-gray-200 px-1">
        <button
          onClick={() => { setActiveTab("roster"); closePanel(); }}
          className={`px-4 py-2.5 text-xs font-bold rounded-t-lg transition-all border-b-2 -mb-px ${
            activeTab === "roster"
              ? "border-[#FBD037] text-[#212121] bg-[#FBD037]/5"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          Shift Roster
        </button>
        <button
          onClick={() => { setActiveTab("shift-change"); closePanel(); }}
          className={`px-4 py-2.5 text-xs font-bold rounded-t-lg transition-all border-b-2 -mb-px ${
            activeTab === "shift-change"
              ? "border-[#FBD037] text-[#212121] bg-[#FBD037]/5"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          Shift Change Management
        </button>
      </div>

      {/* Main Grid: Roster/Table + Sidebar */}
      <div className={`grid gap-4 items-start w-full ${isSidebarOpen ? "grid-cols-12" : "grid-cols-1"}`}>
        
        {/* Table Content Area */}
        <div className={isSidebarOpen ? "col-span-12 xl:col-span-8" : "col-span-12"}>
          
          {/* TAB 1: SHIFT ROSTER */}
          {activeTab === "roster" && (
            <div className="bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl rounded-b-3xl rounded-tr-3xl border border-white/20 shadow-sm overflow-hidden mb-6">
              
              {/* Toolbar Controls */}
              <div className="px-6 py-1.5 flex flex-col lg:flex-row lg:items-center justify-end gap-4 border-b border-slate-50">
                <div className="flex items-center flex-wrap gap-2.5">
                  
                  {/* Date Navigator */}
                  <div className="flex items-center gap-2 border border-slate-200 bg-white rounded-lg px-2.5 h-8 text-sm shadow-sm mr-2">
                    <button onClick={handlePrevWeek} className="text-gray-400 hover:text-gray-600 transition cursor-pointer"><IconChevronLeft size={14} stroke={2.5} /></button>
                    <span className="text-xs font-bold text-gray-850">{formatWeekRange(currentWeekStart)}</span>
                    <button onClick={handleNextWeek} className="text-gray-400 hover:text-gray-600 transition cursor-pointer"><IconChevronRight size={14} stroke={2.5} /></button>
                  </div>

                  {/* Filter */}
                  <button
                    onClick={() => openPanel("filter")}
                    className={`border px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-semibold transition shadow-sm cursor-pointer ${activePanel === "filter" ? "border-[#FBD037] bg-[#FBD037]/10 text-[#212121]" : "border-slate-200 bg-white hover:bg-slate-50 text-slate-700"}`}
                  >
                    <IconFilter size={14} /> Filter
                  </button>

                  {/* Import */}
                  <button
                    onClick={() => openPanel("import")}
                    className={`border px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-semibold transition shadow-sm cursor-pointer ${activePanel === "import" ? "border-[#FBD037] bg-[#FBD037]/10 text-[#212121]" : "border-slate-200 bg-white hover:bg-slate-50 text-slate-700"}`}
                  >
                    <IconUpload size={14} /> Import
                  </button>

                  {/* Export */}
                  <button
                    onClick={() => toast.success("Export started")}
                    className="border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-semibold transition shadow-sm cursor-pointer"
                  >
                    <IconDownload size={14} /> Export
                  </button>

                  {/* View switcher */}
                  <div className="flex items-center bg-white border border-slate-200 rounded-lg p-0.5 shadow-sm h-8">
                    <button className="p-1 rounded bg-[#FBD037] text-[#212121] cursor-pointer"><IconList size={14} /></button>
                    <button className="p-1 rounded text-gray-450 hover:text-gray-600 transition cursor-pointer"><IconCalendar size={14} /></button>
                  </div>

                  {/* Search */}
                  <div className="flex items-center gap-2 relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><IconSearch size={16} className="text-gray-400" /></div>
                    <input type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)}
                      className="pl-9 pr-4 h-8 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:ring-1 focus:ring-[#FBD037] transition" />
                  </div>

                  {/* Add Button */}
                  <button
                    onClick={() => openPanel("add")}
                    className={`flex items-center justify-center w-8 h-8 rounded-lg transition shadow-sm hover:shadow-md cursor-pointer active:scale-95 ${activePanel === "add" ? "bg-[#FACC15]" : "bg-[#FBD037] hover:bg-[#FACC15]"}`}
                  >
                    <IconPlus stroke={2.5} size={16} className="text-[#212121]" />
                  </button>
                </div>
              </div>

              {/* Roster Table */}
              <div className="overflow-auto max-h-[80vh] hide-scrollbar p-2">
                {isRosterLoading ? (
                  <div className="flex items-center justify-center py-20 text-gray-400 text-sm font-medium">
                    <IconRefresh size={18} className="animate-spin mr-2" /> Loading roster data...
                  </div>
                ) : (
                  <table className="w-full text-left border-collapse min-w-[1000px]">
                    <thead>
                      <tr className="text-[#131327]/70 border-gray-300 border-b border-dashed sticky top-0 z-20 shadow-sm bg-[#FCFDF8]">
                        <th className="sticky left-0 z-10 bg-[#FCFDF8] px-6 py-4 min-w-[240px] font-bold text-sm text-[#212121] border-r border-dashed border-gray-300 shadow-[1px_0_0_0_#e5e7eb] text-center">
                          View by employees
                        </th>
                        {getWeekDays(currentWeekStart).map((dayObj, i) => (
                          <th key={i} className="px-4 py-3 min-w-[140px] border-r border-dashed border-gray-300 bg-[#FCFDF8] font-semibold text-xs last:border-r-0 text-center">
                            <div className={`uppercase ${dayObj.isToday ? "text-blue-500 font-bold" : "text-gray-500"}`}>{dayObj.day}</div>
                            <div className={`text-lg font-bold mt-0.5 ${dayObj.isToday ? "text-blue-500" : "text-[#212121]"}`}>{dayObj.date}</div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {rosterPageData.length === 0 ? (
                        <tr>
                          <td colSpan={8} className="text-center py-16 text-gray-400 font-medium text-sm">
                            No employees found.
                          </td>
                        </tr>
                      ) : (
                        rosterPageData.map((emp: any) => {
                          const empId = emp.id || emp._id;
                          const empName = emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || "Employee";
                          const empDept = emp.department?.departmentName || emp.departmentName || "General";

                          return (
                            <tr key={empId} className="group hover:bg-[#FBD037]/10 transition-colors">
                              {/* Employee Profile Cell */}
                              <td className="sticky left-0 z-10 bg-[#FCFDF8] group-hover:bg-[#FCFDF8] px-6 py-3 border-r border-b border-dashed border-gray-300 shadow-[1px_0_0_0_#e5e7eb] transition-colors">
                                <div className="flex items-center gap-3">
                                  <div className="w-9 h-9 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center font-bold text-[#212121] text-sm shrink-0 uppercase">
                                    {empName.charAt(0)}
                                  </div>
                                  <div>
                                    <div className="font-semibold text-sm text-[#212121] whitespace-nowrap">{empName}</div>
                                    <div className="text-xs text-gray-450">{empDept}</div>
                                  </div>
                                </div>
                              </td>

                              {/* 7 Days of the Week Shift Cells */}
                              {getWeekDays(currentWeekStart).map((dayObj, i) => {
                                const r = getRosterForEmployeeOnDate(empId, dayObj.fullDate);
                                if (!r) {
                                  return (
                                    <td key={i} className="p-2 border-r border-b border-dashed border-gray-300 min-w-[140px] text-center">
                                      <div className="flex items-center justify-center h-14 rounded bg-[#EBF3FF] border border-dashed border-[#A0C4FF] text-[#5D87FF] font-semibold text-xs transition">
                                        Week Off
                                      </div>
                                    </td>
                                  );
                                }

                                const shiftName = r.shiftType?.typeName || r.shiftTypeName || r.assignmentType || "-";
                                
                                // Map colors exactly to Hivestaff mockups
                                let shiftColor = r.shiftType?.color;
                                const lowerName = shiftName.toLowerCase();
                                if (lowerName.includes("general")) {
                                  shiftColor = "#FF1919"; // Bright mockup red
                                } else if (lowerName.includes("night")) {
                                  shiftColor = "#5D6BEE"; // Blue
                                } else if (!shiftColor) {
                                  shiftColor = r.assignmentType === "OVERTIME" ? "#FF8C00" : "#5D6BEE";
                                }

                                const startTime = r.startTime || r.shiftType?.startTime || "";
                                const endTime = r.endTime || r.shiftType?.endTime || "";
                                
                                // Helper to format time strings (e.g. "10:00:00" -> "10:00 AM", "17:30" -> "05:30 PM")
                                const formatTimeTo12Hour = (timeStr: string) => {
                                  if (!timeStr) return "";
                                  const parts = timeStr.split(":");
                                  if (parts.length < 2) return timeStr;
                                  let hours = parseInt(parts[0], 10);
                                  const minutes = parts[1];
                                  const ampm = hours >= 12 ? "PM" : "AM";
                                  hours = hours % 12;
                                  hours = hours ? hours : 12;
                                  const strHours = hours.toString().padStart(2, "0");
                                  return `${strHours}:${minutes} ${ampm}`;
                                };

                                const timeRange = startTime && endTime ? `${formatTimeTo12Hour(startTime)} - ${formatTimeTo12Hour(endTime)}` : "-";

                                return (
                                  <td key={i} className="p-2 border-r border-b border-dashed border-gray-300 min-w-[140px]">
                                    <div 
                                      className="flex flex-col justify-center items-center px-2 h-14 rounded text-white cursor-pointer hover:opacity-95 transition relative group/cell font-sans"
                                      style={{ backgroundColor: shiftColor }}
                                    >
                                      <div className="flex items-center gap-1 font-bold text-xs">
                                        <IconClock size={12} className="shrink-0" />
                                        <span className="truncate max-w-[110px]">{shiftName}</span>
                                      </div>
                                      <div className="text-[9px] mt-0.5 opacity-90">{timeRange}</div>
                                      
                                      {/* Cell Hover edit/delete action overlay */}
                                      <div className="absolute inset-0 bg-black/75 rounded flex items-center justify-center gap-2 opacity-0 group-hover/cell:opacity-100 transition-opacity">
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setEditingRoster(r);
                                            setEditRosterAssignmentType(r.assignmentType || "SHIFT");
                                            setEditRosterShiftTypeId(r.shiftType?.id || r.shiftType?._id || r.shiftTypeId || "");
                                            setEditRosterWorkingFromId(r.workingFrom?.id || r.workingFrom?._id || r.workingFromId || "");
                                            setEditRosterRemark(r.remark || "");
                                            setEditRosterStartTime(r.startTime || "");
                                            setEditRosterEndTime(r.endTime || "");
                                            setShowEditRosterModal(true);
                                          }}
                                          className="p-1 bg-white text-blue-600 rounded hover:scale-105 transition cursor-pointer"
                                          title="Edit"
                                        >
                                          <IconEdit size={12} />
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => { setDeletingRoster(r); setShowDeleteRosterModal(true); }}
                                          className="p-1 bg-white text-red-600 rounded hover:scale-105 transition cursor-pointer"
                                          title="Delete"
                                        >
                                          <IconTrash size={12} />
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Roster Pagination */}
              <div className="flex items-center justify-between px-6 py-3 border-t border-slate-100 text-xs font-semibold text-gray-500 bg-slate-50/10">
                <span>Record {rosterFilteredEmployees.length === 0 ? "0-0" : `${(rosterPage - 1) * rosterPerPage + 1}-${Math.min(rosterPage * rosterPerPage, rosterFilteredEmployees.length)}`} of {rosterFilteredEmployees.length}</span>
                <div className="flex items-center gap-2">
                  <div className="relative mr-2">
                    <select
                      value={rosterPerPage}
                      onChange={e => { setRosterPerPage(Number(e.target.value)); setRosterPage(1); }}
                      className="appearance-none h-8 pl-3 pr-7 rounded-lg border border-slate-200 bg-white text-xs font-semibold text-slate-650 focus:outline-none focus:ring-1 focus:ring-[#FBD037] shadow-sm cursor-pointer"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <IconChevronDown size={11} className="absolute right-2.5 top-2.5 text-gray-400 pointer-events-none" />
                  </div>
                  <button
                    disabled={rosterPage === 1}
                    onClick={() => setRosterPage(p => Math.max(1, p - 1))}
                    className="w-6 h-6 rounded border border-gray-200 flex items-center justify-center hover:bg-gray-50 disabled:opacity-40 transition cursor-pointer bg-white"
                  >
                    <IconChevronLeft size={12} />
                  </button>
                  <span className="text-[#212121] font-bold">{rosterPage}/{rosterTotalPages || 1}</span>
                  <button
                    disabled={rosterPage >= rosterTotalPages}
                    onClick={() => setRosterPage(p => Math.min(rosterTotalPages, p + 1))}
                    className="w-6 h-6 rounded border border-gray-200 flex items-center justify-center hover:bg-gray-50 disabled:opacity-40 transition cursor-pointer bg-white"
                  >
                    <IconChevronRight size={12} />
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* TAB 2: SHIFT CHANGE MANAGEMENT */}
          {activeTab === "shift-change" && (
            <div className="bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden mb-6 animate-in fade-in duration-200">
              
              {/* Order-style Toolbar Header */}
              <div className="px-6 py-3 flex items-center justify-between border-b border-slate-100 flex-wrap gap-4 bg-slate-50/20">
                
                {/* Search Bar Collapsible or Neat Field */}
                <div className="flex items-center gap-2">
                  {scSearchOpen ? (
                    <div className="relative animate-in slide-in-from-left-2 duration-150">
                      <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                        <IconSearch size={14} className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={scSearch}
                        onChange={e => { setScSearch(e.target.value); setScPage(1); }}
                        className="pl-8 pr-8 h-8 rounded-lg border border-slate-200 bg-white text-xs outline-none focus:ring-1 focus:ring-[#FBD037] transition w-52"
                        autoFocus
                      />
                      <button
                        onClick={() => { setScSearch(""); setScSearchOpen(false); }}
                        className="absolute inset-y-0 right-0 pr-2 flex items-center text-gray-400 hover:text-gray-600"
                      >
                        <IconX size={12} />
                      </button>
                    </div>
                  ) : null}
                </div>

                {/* Grid of buttons exactly matching Order table icon blocks */}
                <div className="flex items-center gap-1.5 ml-auto">
                  
                  {/* Filter Button */}
                  <button
                    onClick={() => openPanel("sc-filter")}
                    className={`w-8 h-8 rounded-lg border flex items-center justify-center transition shadow-sm cursor-pointer ${
                      activePanel === "sc-filter"
                        ? "border-[#FBD037] bg-[#FBD037]/15 text-[#212121]"
                        : "border-slate-200 bg-white hover:bg-slate-50 text-slate-600"
                    }`}
                    title="Filter"
                  >
                    <IconFilter size={15} />
                  </button>

                  {/* Search Trigger Button */}
                  <button
                    onClick={() => setScSearchOpen(prev => !prev)}
                    className={`w-8 h-8 rounded-lg border flex items-center justify-center transition shadow-sm cursor-pointer ${
                      scSearchOpen
                        ? "border-[#FBD037] bg-[#FBD037]/15 text-[#212121]"
                        : "border-slate-200 bg-white hover:bg-slate-50 text-slate-600"
                    }`}
                    title="Search"
                  >
                    <IconSearch size={15} />
                  </button>

                  {/* Refresh Button */}
                  <button
                    onClick={() => {
                      toast.success("Data refreshed");
                      setScPage(1);
                    }}
                    className="w-8 h-8 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 flex items-center justify-center transition shadow-sm cursor-pointer"
                    title="Refresh"
                  >
                    <IconRefresh size={15} />
                  </button>

                  {/* Import Button */}
                  <button
                    onClick={() => openPanel("import")}
                    className="w-8 h-8 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 flex items-center justify-center transition shadow-sm cursor-pointer"
                    title="Import"
                  >
                    <IconUpload size={15} />
                  </button>

                  {/* Export Button */}
                  <button
                    onClick={() => toast.success("Exporting table data...")}
                    className="w-8 h-8 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 flex items-center justify-center transition shadow-sm cursor-pointer"
                    title="Export"
                  >
                    <IconDownload size={15} />
                  </button>

                  {/* Page Size Select Dropdown */}
                  <div className="relative">
                    <select
                      value={scPerPage}
                      onChange={e => { setScPerPage(Number(e.target.value)); setScPage(1); }}
                      className="appearance-none h-8 pl-3 pr-7 rounded-lg border border-slate-200 bg-white text-xs font-semibold text-slate-600 focus:outline-none focus:ring-1 focus:ring-[#FBD037] shadow-sm cursor-pointer"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <IconChevronDown size={11} className="absolute right-2.5 top-2.5 text-gray-400 pointer-events-none" />
                  </div>

                  {/* Settings slider/config button */}
                  <button className="w-8 h-8 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 flex items-center justify-center transition shadow-sm cursor-pointer">
                    <IconSettings size={15} />
                  </button>

                  {/* Double check / columns button */}
                  <button className="w-8 h-8 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 flex items-center justify-center transition shadow-sm cursor-pointer">
                    <IconChecklist size={15} />
                  </button>

                  {/* Add Request Button (Yellow) */}
                  <button
                    onClick={() => openPanel("add")}
                    className="w-8 h-8 rounded-lg bg-[#FBD037] hover:bg-[#FACC15] text-[#212121] flex items-center justify-center transition shadow-sm active:scale-95 cursor-pointer ml-1"
                    title="Add Request"
                  >
                    <IconPlus stroke={2.5} size={15} />
                  </button>

                </div>
              </div>

              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse min-w-[960px]">
                  <thead>
                    <tr className="border-b border-dashed border-gray-200 bg-[#FCFDF8]">
                      <th className="px-4 py-3.5 w-10">
                        <input type="checkbox" checked={scChecked.length === scPageData.length && scPageData.length > 0}
                          onChange={toggleAllSc} className="accent-[#212121] w-3.5 h-3.5 rounded cursor-pointer" />
                      </th>
                      {["DATE", "REQUESTED TYPE", "EMPLOYEE", "REQUESTED NEW SHIFT", "EXTRA SHIFT TIME", "PROCESSED BY", "STATUS", "ACTIONS"].map(col => (
                        <th key={col} className="px-4 py-3.5 text-[10px] font-extrabold text-gray-400 uppercase tracking-wide whitespace-nowrap">{col}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {scPageData.length === 0 ? (
                      <tr><td colSpan={9} className="text-center py-16 text-gray-400 font-medium text-sm">No records found</td></tr>
                    ) : (
                      scPageData.map(row => (
                        <tr key={row.id} className={`group hover:bg-slate-50 transition-colors ${scChecked.includes(row.id) ? "bg-[#FBD037]/5" : ""}`}>
                          <td className="px-4 py-3.5">
                            <input type="checkbox" checked={scChecked.includes(row.id)} onChange={() => toggleScRow(row.id)}
                              className="accent-[#212121] w-3.5 h-3.5 rounded cursor-pointer" />
                          </td>
                          <td className="px-4 py-3.5 text-xs font-semibold text-gray-700 whitespace-nowrap">{row.date}</td>
                          <td className="px-4 py-3.5">
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${
                              row.requestedType === "Extra Shift Request"
                                ? "bg-blue-50 text-blue-600"
                                : "bg-purple-50 text-purple-600"
                            }`}>
                              {row.requestedType}
                            </span>
                          </td>
                          <td className="px-4 py-3.5">
                            <div className="flex items-center gap-2.5 min-w-[160px]">
                              <AvatarBadge name={row.employee.name} />
                              <div>
                                <div className="text-xs font-bold text-[#212121] whitespace-nowrap">{row.employee.name}</div>
                                <div className="text-[10px] text-gray-400 font-medium whitespace-nowrap">{row.employee.department}</div>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3.5 text-xs font-semibold text-gray-700 capitalize whitespace-nowrap">{row.requestedNewShift}</td>
                          <td className="px-4 py-3.5 text-xs font-semibold text-gray-600 whitespace-nowrap">{row.extraShiftTime}</td>
                          <td className="px-4 py-3.5">
                            <div className="flex items-center gap-2.5 min-w-[150px]">
                              <div className="w-8 h-8 rounded-full bg-[#212121] flex items-center justify-center text-[10px] font-bold text-white shrink-0">
                                {row.processedBy.avatar}
                              </div>
                              <div>
                                <div className="text-xs font-bold text-[#212121] whitespace-nowrap">{row.processedBy.name}</div>
                                <div className="text-[10px] text-gray-400 font-medium whitespace-nowrap">{row.processedBy.department}</div>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3.5">
                            <div className="flex items-center gap-2">
                              <StatusBadge status={row.status} />
                              <IconChevronDown size={12} className="text-gray-400" />
                            </div>
                          </td>
                          <td className="px-4 py-3.5">
                            <button
                              onClick={() => toast(`Actions for ${row.employee.name}`)}
                              className="w-7 h-7 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:text-[#212121] hover:bg-gray-100 transition cursor-pointer"
                            >
                              <IconRefresh size={14} />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex items-center justify-between px-6 py-3 border-t border-slate-100 text-xs font-semibold text-gray-500 bg-slate-50/10">
                <span>Record {scFiltered.length === 0 ? "0-0" : `${(scPage - 1) * scPerPage + 1}-${Math.min(scPage * scPerPage, scFiltered.length)}`} of {scFiltered.length}</span>
                <div className="flex items-center gap-2">
                  <span className="text-gray-400">{scPerPage}</span>
                  <button
                    disabled={scPage === 1}
                    onClick={() => setScPage(p => Math.max(1, p - 1))}
                    className="w-6 h-6 rounded border border-gray-200 flex items-center justify-center hover:bg-gray-50 disabled:opacity-40 transition cursor-pointer bg-white"
                  >
                    <IconChevronLeft size={12} />
                  </button>
                  <span className="text-[#212121] font-bold">{scPage}/{scTotalPages || 1}</span>
                  <button
                    disabled={scPage >= scTotalPages}
                    onClick={() => setScPage(p => Math.min(scTotalPages, p + 1))}
                    className="w-6 h-6 rounded border border-gray-200 flex items-center justify-center hover:bg-gray-50 disabled:opacity-40 transition cursor-pointer bg-white"
                  >
                    <IconChevronRight size={12} />
                  </button>
                </div>
              </div>

            </div>
          )}

        </div>

        {/* Sidebar Slide-in Panel */}
        {isSidebarOpen && (
          <div className="col-span-12 xl:col-span-4">
            <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-250 font-sans sticky top-2">
              
              {/* Sidebar Header */}
              <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
                <h2 className="text-lg font-bold text-[#212121]">
                  {activePanel === "add" && "Add Shift"}
                  {activePanel === "import" && "Import Data"}
                  {activePanel === "filter" && "Filter Shifts"}
                  {activePanel === "sc-filter" && "Filter Shift Changes"}
                </h2>
                <button
                  type="button"
                  onClick={closePanel}
                  className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-750 cursor-pointer bg-white"
                >
                  <IconX size={18} />
                </button>
              </div>

              {/* ── Add Shift / Request Panel ── */}
              {activePanel === "add" && (
                <form onSubmit={handleAddSubmit} className="p-6 space-y-5 max-h-[calc(100vh-160px)] overflow-y-auto text-left hide-scrollbar bg-white">
                  {/* Mode selection */}
                  <div className="flex gap-6 text-sm font-semibold">
                    {(["shift", "overtime"] as const).map(m => (
                      <label key={m} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="addMode" checked={addMode === m} onChange={() => setAddMode(m)} className="accent-[#212121] w-4 h-4" />
                        <div>
                          <div className="text-sm font-bold text-[#212121]">{m === "shift" ? "Add Shift" : "Add Over Time"}</div>
                          <div className="text-[10px] text-gray-400 font-medium">{m === "shift" ? "Create New Shift" : "Create Shift Over Time"}</div>
                        </div>
                      </label>
                    ))}
                  </div>

                  {/* Assign By */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Assign Shift By</label>
                    <div className="flex gap-5 text-xs font-semibold">
                      {(["date", "multiple", "month"] as const).map(mode => (
                        <label key={mode} className="flex items-center gap-1.5 cursor-pointer">
                          <input type="radio" name="assignBy" checked={assignBy === mode} onChange={() => setAssignBy(mode)} className="accent-[#212121]" />
                          <span className="capitalize text-slate-700">{mode === "date" ? "Single Date" : mode === "multiple" ? "Date Range" : "Month"}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Shift Type + Date */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-1.5">
                      <label className="block text-xs font-bold text-[#1E293B]">Shift Type <span className="text-red-500">*</span></label>
                      <div className="flex gap-1.5">
                        <select value={shiftType} onChange={e => setShiftType(e.target.value)} required
                          className="flex-1 px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                          <option value="">Select Shift Type...</option>
                          {dbShiftTypes.map(s => (
                            <option key={s.id || s._id} value={s.id || s._id}>{s.typeName || s.shiftName}</option>
                          ))}
                        </select>
                        <button type="button" onClick={() => setShowCreateShiftModal(true)}
                          className="w-8 h-8 bg-[#212121] rounded-lg flex items-center justify-center text-white cursor-pointer shrink-0 hover:bg-black transition-colors">
                          <IconPlus size={14} />
                        </button>
                      </div>
                    </div>

                    {/* Date field(s) based on assignBy mode */}
                    {assignBy === "date" && (
                      <div className="space-y-1.5">
                        <label className="block text-xs font-bold text-[#1E293B]">Roster Date <span className="text-red-500">*</span></label>
                        <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-white focus-within:ring-1 focus-within:ring-[#FBD037]">
                          <IconCalendarEvent size={14} className="text-gray-400 shrink-0" />
                          <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} required
                            className="flex-1 outline-none text-xs font-semibold text-[#212121] bg-transparent" />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Date range for MULTIPLE mode */}
                  {assignBy === "multiple" && (
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-1.5">
                        <label className="block text-xs font-bold text-[#1E293B]">From Date <span className="text-red-500">*</span></label>
                        <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} required
                          className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" />
                      </div>
                      <div className="space-y-1.5">
                        <label className="block text-xs font-bold text-[#1E293B]">To Date <span className="text-red-500">*</span></label>
                        <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} required
                          className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" />
                      </div>
                    </div>
                  )}

                  {/* Custom Start/End Time (for overtime or custom) */}
                  {addMode === "overtime" && (
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-1.5">
                        <label className="block text-xs font-bold text-[#1E293B]">Start Time</label>
                        <input type="time" value={rosterStartTime} onChange={e => setRosterStartTime(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" />
                      </div>
                      <div className="space-y-1.5">
                        <label className="block text-xs font-bold text-[#1E293B]">End Time</label>
                        <input type="time" value={rosterEndTime} onChange={e => setRosterEndTime(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" />
                      </div>
                    </div>
                  )}

                  {/* Employees */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Employees <span className="text-red-500">*</span></label>
                    <select value={employee} onChange={e => setEmployee(e.target.value)}
                      className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                      <option value="">Select Employee...</option>
                      {dbEmployees.map((emp: any) => (
                        <option key={emp.id || emp._id} value={emp.id || emp._id}>
                          {emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Working From */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Working From</label>
                    <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-white focus-within:ring-1 focus-within:ring-[#FBD037]">
                      <IconMapPin size={14} className="text-gray-400 shrink-0" />
                      <select value={workingFromId} onChange={e => setWorkingFromId(e.target.value)}
                        className="flex-1 outline-none text-xs font-semibold text-[#212121] bg-transparent">
                        <option value="">Select Working From...</option>
                        {dbWorkingFrom.length > 0 ? (
                          dbWorkingFrom.map((wf: any) => (
                            <option key={wf.id || wf._id} value={wf.id || wf._id}>
                              {wf.location || wf.name || wf.locationName}
                            </option>
                          ))
                        ) : (
                          <>
                            <option value="office">Office</option>
                            <option value="wfh">Work From Home</option>
                            <option value="field">On Field</option>
                          </>
                        )}
                      </select>
                    </div>
                  </div>

                  {/* Remark */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Remark</label>
                    <textarea value={remark} onChange={e => setRemark(e.target.value)} rows={3} placeholder="Enter remarks..."
                      className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] resize-none" />
                  </div>

                  {/* File Upload */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Document (optional)</label>
                    <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-xl p-4 flex flex-col items-center gap-2 relative cursor-pointer bg-slate-50/10">
                      <input type="file" accept="image/*,application/pdf" onChange={e => setRosterDocument(e.target.files?.[0] || null)}
                        className="absolute inset-0 opacity-0 cursor-pointer" />
                      <IconUpload size={20} className="text-gray-400" />
                      <div className="text-xs font-bold text-slate-800">{rosterDocument ? rosterDocument.name : "Drag & drop or click to browse"}</div>
                      <div className="text-[10px] text-gray-400">Max 3MB • image/*, application/pdf</div>
                    </div>
                  </div>

                  {/* Overwrite checkbox */}
                  <label className="flex items-center gap-2 text-xs font-semibold text-slate-650 cursor-pointer">
                    <input type="checkbox" checked={overwriteShift} onChange={e => setOverwriteShift(e.target.checked)} className="accent-[#212121] w-3.5 h-3.5" />
                    Overwrite existing shift for same date
                  </label>

                  <div className="flex justify-end gap-3 pt-4 border-t border-slate-100 font-bold">
                    <button type="button" onClick={closePanel} className="px-5 py-2 border border-gray-200 hover:bg-gray-50 text-xs font-semibold rounded-xl text-slate-700 transition cursor-pointer bg-white">Cancel</button>
                    <button type="submit" disabled={isRosterSubmitting}
                      className="px-6 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#212121] hover:bg-black text-white transition cursor-pointer border-none disabled:opacity-60">
                      {isRosterSubmitting ? "Saving..." : "Save Shift"}
                    </button>
                  </div>
                </form>
              )}

              {/* ── Import Panel ── */}
              {activePanel === "import" && (
                <div className="p-6 space-y-6 max-h-[calc(100vh-160px)] overflow-y-auto text-left hide-scrollbar bg-white">
                  <div className="p-4 rounded-xl border border-blue-100 bg-blue-50/40 text-xs">
                    <div className="font-bold text-slate-800">Before uploading the sheet, please ensure that the following fields are included in the Excel file:</div>
                    <div className="text-gray-500 font-medium mt-1">
                      Make sure headers match exactly (case-insensitive). Missing fields may cause import errors.
                      <span onClick={() => toast("Required: Employee ID, Shift Type, Date, Working From, Remark")}
                        className="text-blue-500 hover:underline font-bold ml-1.5 cursor-pointer">Show fields</span>
                    </div>
                  </div>

                  <div className="p-4 rounded-xl border border-gray-200 bg-slate-50 flex items-center justify-between gap-4">
                    <div className="text-xs text-left">
                      <div className="font-bold text-slate-800">Need a sample file to understand the import format?</div>
                      <div className="text-gray-400 font-medium mt-0.5 leading-relaxed">Download the template and upload your data in the same structure.</div>
                    </div>
                    <button onClick={() => toast.success("Sample template downloaded")}
                      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-50 text-xs font-bold text-slate-700 transition cursor-pointer shrink-0 shadow-sm bg-white">
                      <IconDownload size={14} className="text-gray-400" /> Sample File
                    </button>
                  </div>

                  <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-10 flex flex-col items-center justify-center gap-2 cursor-pointer bg-slate-50/20 relative">
                    <input type="file" accept=".xlsx,.xls,.xlsm" onChange={e => { const f = e.target.files?.[0]; if (f) toast.success(`File selected: ${f.name}`); }} className="absolute inset-0 opacity-0 cursor-pointer" />
                    <IconUpload size={28} className="text-gray-400" />
                    <div className="text-xs font-bold text-slate-800 text-center">Click or drag an Excel file here</div>
                    <button className="mt-1 px-3.5 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200/80 text-[10px] font-black uppercase text-slate-600 transition tracking-wide">Choose file</button>
                    <div className="text-[10px] text-gray-400 mt-1">Allowed: .xlsx, .xls, .xlsm • Max 20 MB</div>
                  </div>

                  <div className="pt-4 flex justify-end gap-2.5 border-t border-slate-100">
                    <button onClick={closePanel} className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white">Cancel</button>
                    <button onClick={() => { toast.success("Opening editor..."); closePanel(); }} className="px-5 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#64748B] hover:bg-[#475569] text-white transition cursor-pointer border-none">Open Editor</button>
                  </div>
                </div>
              )}

              {/* ── Shift Roster Filter Panel ── */}
              {activePanel === "filter" && (
                <div className="p-6 space-y-5 max-h-[calc(100vh-160px)] overflow-y-auto text-left hide-scrollbar bg-white">
                  {[
                    { label: "Department", icon: <IconBriefcase size={12} className="inline mr-1 text-gray-400" />, value: filterDept, onChange: setFilterDept, options: MOCK_DEPARTMENTS },
                    { label: "Employee", icon: <IconUsers size={12} className="inline mr-1 text-gray-400" />, value: filterEmp, onChange: setFilterEmp, options: MOCK_EMPLOYEES_LIST },
                    { label: "Shift Type", icon: <IconClock size={12} className="inline mr-1 text-gray-400" />, value: filterShift, onChange: setFilterShift, options: MOCK_SHIFT_TYPES_LIST },
                  ].map(f => (
                    <div key={f.label} className="space-y-1.5">
                      <label className="block text-xs font-bold text-[#1E293B]">{f.icon}{f.label}</label>
                      <select value={f.value} onChange={e => f.onChange(e.target.value)}
                        className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                        {f.options.map(o => <option key={o}>{o}</option>)}
                      </select>
                    </div>
                  ))}

                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-1.5">
                      <label className="block text-xs font-bold text-[#1E293B]">Month</label>
                      <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)}
                        className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                        <option value="">Select Month...</option>
                        {["January","February","March","April","May","June","July","August","September","October","November","December"].map(m => <option key={m}>{m}</option>)}
                      </select>
                    </div>
                    <div className="space-y-1.5">
                      <label className="block text-xs font-bold text-[#1E293B]">Year</label>
                      <select value={filterYear} onChange={e => setFilterYear(e.target.value)}
                        className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                        <option value="">Select Year...</option>
                        {["2024","2025","2026","2027"].map(y => <option key={y}>{y}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className="pt-4 flex justify-end gap-2.5 border-t border-slate-100">
                    <button onClick={handleFilterClear} className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white">Clear</button>
                    <button onClick={handleFilterApply} className="flex items-center gap-1.5 px-5 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#212121] hover:bg-black text-white transition cursor-pointer border-none">
                      <IconCheck size={13} /> Apply Filters
                    </button>
                  </div>
                </div>
              )}

              {/* ── Shift Change Management Filter Panel ── */}
              {activePanel === "sc-filter" && (
                <div className="p-6 space-y-5 max-h-[calc(100vh-160px)] overflow-y-auto text-left hide-scrollbar bg-white">
                  
                  {/* Select Employee */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">
                      <IconUsers size={12} className="inline mr-1 text-gray-400" />Employee
                    </label>
                    <select
                      value={scFilterEmp}
                      onChange={e => setScFilterEmp(e.target.value)}
                      className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                    >
                      {MOCK_EMPLOYEES_LIST.map(emp => (
                        <option key={emp} value={emp}>{emp}</option>
                      ))}
                    </select>
                  </div>

                  {/* Requested Type */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">
                      <IconBriefcase size={12} className="inline mr-1 text-gray-400" />Request Type
                    </label>
                    <select
                      value={scFilterType}
                      onChange={e => setScFilterType(e.target.value)}
                      className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                    >
                      <option value="All Types">All Types</option>
                      <option value="Extra Shift Request">Extra Shift Request</option>
                      <option value="Shift Change Request">Shift Change Request</option>
                    </select>
                  </div>

                  {/* Requested Shift */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">
                      <IconClock size={12} className="inline mr-1 text-gray-400" />Requested New Shift
                    </label>
                    <select
                      value={scFilterShift}
                      onChange={e => setScFilterShift(e.target.value)}
                      className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                    >
                      {MOCK_SHIFT_TYPES_LIST.map(sh => (
                        <option key={sh} value={sh}>{sh}</option>
                      ))}
                    </select>
                  </div>

                  {/* Status */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Status</label>
                    <select
                      value={scFilterStatus}
                      onChange={e => setScFilterStatus(e.target.value)}
                      className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                    >
                      <option value="All Statuses">All Statuses</option>
                      <option value="Approved">Approved</option>
                      <option value="Pending">Pending</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>

                  {/* Date */}
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Select Date</label>
                    <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-white focus-within:ring-1 focus-within:ring-[#FBD037]">
                      <IconCalendarEvent size={14} className="text-gray-400 shrink-0" />
                      <input
                        type="date"
                        value={scFilterDate}
                        onChange={e => setScFilterDate(e.target.value)}
                        className="flex-1 outline-none text-xs font-semibold text-[#212121] bg-transparent"
                      />
                    </div>
                  </div>

                  {/* Clear / Apply Buttons */}
                  <div className="pt-4 flex justify-end gap-2.5 border-t border-slate-100 font-bold">
                    <button
                      onClick={handleScFilterClear}
                      className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white"
                    >
                      Clear
                    </button>
                    <button
                      onClick={handleScFilterApply}
                      className="flex items-center gap-1.5 px-5 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#212121] hover:bg-black text-white transition cursor-pointer border-none"
                    >
                      <IconCheck size={13} /> Apply Filters
                    </button>
                  </div>

                </div>
              )}

            </div>
          </div>
        )}

      </div>

      {/* ── Create Shift Modal ── */}
      {showCreateShiftModal && (
        <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-[9999] flex items-center justify-center p-4 overflow-y-auto animate-in fade-in duration-200">
          <div className="bg-white rounded-3xl max-w-3xl w-full shadow-xl overflow-hidden animate-in zoom-in-95 duration-200">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-[#212121]">Create Shift</h2>
              <button
                type="button"
                onClick={() => setShowCreateShiftModal(false)}
                className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition"
              >
                <IconX size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleCreateShiftSubmit} className="p-6 space-y-4 text-left">
              {/* Row 1 */}
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Shift Name <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    required
                    placeholder="Ex. Night Shift"
                    value={newShiftName}
                    onChange={(e) => setNewShiftName(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Shift Code <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    required
                    placeholder="Enter short code (Ex. MOR)"
                    value={newShiftCode}
                    onChange={(e) => setNewShiftCode(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Breaks</label>
                  <select
                    value={newBreakIds[0] || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewBreakIds(val ? [val] : []);
                    }}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  >
                    <option value="">Select A Break</option>
                    {dbBreaks.map((b) => (
                      <option key={b.id} value={b.id}>{b.text}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Total Break Duration (min)</label>
                  <input
                    type="number"
                    disabled
                    value={newTotalBreakDuration || "0"}
                    className="w-full px-3 py-2 bg-slate-50 border border-gray-200 rounded-xl outline-none text-xs font-semibold text-gray-500 cursor-not-allowed"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Start Time <span className="text-red-500">*</span></label>
                  <input
                    type="time"
                    required
                    value={newStartTime}
                    onChange={(e) => setNewStartTime(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">End Time <span className="text-red-500">*</span></label>
                  <input
                    type="time"
                    required
                    value={newEndTime}
                    onChange={(e) => setNewEndTime(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Half Time *</label>
                  <input
                    type="text"
                    disabled
                    value={newHalfTime || "Auto-calculated"}
                    className="w-full px-3 py-2 bg-slate-50 border border-gray-200 rounded-xl outline-none text-xs font-semibold text-gray-500 cursor-not-allowed"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Early Clock In (min) <span className="text-red-500">*</span></label>
                  <input
                    type="number"
                    required
                    placeholder="Enter minutes before start"
                    value={newEarlyClockInMinutes}
                    onChange={(e) => setNewEarlyClockInMinutes(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Late Mark After (min) <span className="text-red-500">*</span></label>
                  <input
                    type="number"
                    required
                    placeholder="Enter minutes after start"
                    value={newLateMarkAfterMinutes}
                    onChange={(e) => setNewLateMarkAfterMinutes(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
              </div>

              {/* Row 4 */}
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Max Check-in</label>
                  <input
                    type="number"
                    value={newMaxCheckIn}
                    onChange={(e) => setNewMaxCheckIn(e.target.value)}
                    placeholder="1"
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  />
                </div>
                <div className="space-y-1.5 col-span-2">
                  <MultiSelectInput
                    name="officeOpenDays"
                    label="Office Opens On *"
                    placeholder="Select Day..."
                    selectOptions={DAY_OPTIONS}
                    value={newOfficeOpenDays}
                    onChange={setNewOfficeOpenDays}
                  />
                </div>
              </div>

              {/* Row 5 */}
              <div className="flex items-center gap-4 pt-2">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Color</label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      value={newColor}
                      onChange={(e) => setNewColor(e.target.value)}
                      className="px-3 py-2 w-28 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                      placeholder="#FF0000"
                    />
                    <div className="relative w-10 h-8 rounded-lg border border-gray-200 overflow-hidden flex-shrink-0">
                      <input
                        type="color"
                        value={newColor}
                        onChange={(e) => setNewColor(e.target.value)}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />
                      <div className="w-full h-full" style={{ backgroundColor: newColor }} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="pt-4 flex justify-end gap-2.5 border-t border-slate-100">
                <button
                  type="button"
                  onClick={() => setShowCreateShiftModal(false)}
                  className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmittingShift}
                  className="px-5 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#212121] hover:bg-black text-white transition cursor-pointer border-none"
                >
                  {isSubmittingShift ? "Creating..." : "Create Shift"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Departments Modal ── */}
      {showDepartmentsModal && (
        <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-[9999] flex items-center justify-center p-4 overflow-y-auto animate-in fade-in duration-200">
          <div className="bg-white rounded-3xl max-w-xl w-full shadow-xl overflow-hidden animate-in zoom-in-95 duration-200">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-[#212121]">Departments</h2>
              <button
                type="button"
                onClick={() => {
                  setShowDepartmentsModal(false);
                  setEditingDeptId(null);
                  setNewDeptName("");
                }}
                className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition"
              >
                <IconX size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-6">
              {/* Input Form */}
              <form onSubmit={handleDepartmentSubmit} className="space-y-2 text-left">
                <label className="block text-xs font-bold text-[#1E293B]">
                  Name <span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    required
                    placeholder="Enter Department name"
                    value={newDeptName}
                    onChange={(e) => setNewDeptName(e.target.value)}
                    className="flex-1 px-3 py-2.5 text-xs rounded-xl border border-gray-200 outline-none focus:ring-1 focus:ring-[#FBD037] focus:border-[#FBD037] text-gray-800 bg-white font-semibold"
                  />
                  <button
                    type="submit"
                    disabled={isSubmittingDept}
                    className="px-4 py-2.5 bg-black hover:bg-gray-800 text-white font-bold text-xs rounded-xl transition flex items-center gap-1.5 border-none shadow-sm cursor-pointer"
                  >
                    <IconUpload size={14} /> Submit
                  </button>
                </div>
                {newDeptName === "" && (
                  <div className="text-[10px] text-red-500 font-semibold mt-1">Department is required</div>
                )}
              </form>

              {/* List Table */}
              <div className="max-h-[300px] overflow-y-auto border border-gray-100 rounded-xl">
                <table className="w-full text-xs text-left">
                  <thead className="bg-slate-50 text-gray-500 font-bold uppercase tracking-wider text-[10px] sticky top-0">
                    <tr>
                      <th className="px-4 py-3 w-12 text-center">Sr</th>
                      <th className="px-4 py-3">Name</th>
                      <th className="px-4 py-3 text-center w-24">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {dbDepartments.length > 0 ? (
                      dbDepartments.map((d: any, index: number) => (
                        <tr key={d.id || d._id} className="hover:bg-slate-50 transition-colors">
                          <td className="px-4 py-2 text-gray-400 font-semibold text-center">{index + 1}</td>
                          <td className="px-4 py-2 font-semibold text-gray-850">{d.departmentName}</td>
                          <td className="px-4 py-2 text-center">
                            <div className="flex items-center justify-center gap-2">
                              <button
                                type="button"
                                onClick={() => {
                                  setEditingDeptId(d.id || d._id);
                                  setNewDeptName(d.departmentName);
                                }}
                                className="p-1.5 rounded border border-gray-200 hover:bg-gray-50 text-slate-500 transition cursor-pointer bg-white"
                              >
                                <IconEdit size={12} />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDeleteDepartment(d.id || d._id)}
                                className="p-1.5 rounded border border-red-100 hover:bg-red-50 text-red-500 transition cursor-pointer bg-white"
                              >
                                <IconTrash size={12} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      MOCK_DEPARTMENTS.slice(1).map((dept: string, index: number) => (
                        <tr key={dept} className="hover:bg-slate-50 transition-colors">
                          <td className="px-4 py-2 text-gray-400 font-semibold text-center">{index + 1}</td>
                          <td className="px-4 py-2 font-semibold text-gray-850">{dept}</td>
                          <td className="px-4 py-2 text-center text-gray-400 font-medium italic">
                            —
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ── Edit Roster Modal ── */}
      {showEditRosterModal && editingRoster && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md animate-in fade-in zoom-in-95 duration-200">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-base font-bold text-[#212121]">Edit Roster</h2>
              <button onClick={() => setShowEditRosterModal(false)} className="p-1.5 rounded-lg border border-gray-200 hover:bg-gray-100 transition cursor-pointer">
                <IconX size={16} />
              </button>
            </div>
            <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto hide-scrollbar">

              {/* Assignment Type */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Assignment Type</label>
                <div className="flex gap-4 text-xs font-semibold">
                  {["SHIFT", "OVERTIME"].map(t => (
                    <label key={t} className="flex items-center gap-1.5 cursor-pointer">
                      <input type="radio" checked={editRosterAssignmentType === t} onChange={() => setEditRosterAssignmentType(t)} className="accent-[#212121]" />
                      <span className="text-slate-700">{t}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Shift Type (only for SHIFT) */}
              {editRosterAssignmentType === "SHIFT" && (
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Shift Type</label>
                  <select value={editRosterShiftTypeId} onChange={e => setEditRosterShiftTypeId(e.target.value)}
                    className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                    <option value="">Select Shift Type...</option>
                    {dbShiftTypes.map((s: any) => (
                      <option key={s.id || s._id} value={s.id || s._id}>{s.typeName || s.shiftName}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Time (only for OVERTIME) */}
              {editRosterAssignmentType === "OVERTIME" && (
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Start Time</label>
                    <input type="time" value={editRosterStartTime} onChange={e => setEditRosterStartTime(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold" />
                  </div>
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">End Time</label>
                    <input type="time" value={editRosterEndTime} onChange={e => setEditRosterEndTime(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold" />
                  </div>
                </div>
              )}

              {/* Working From */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Working From</label>
                <select value={editRosterWorkingFromId} onChange={e => setEditRosterWorkingFromId(e.target.value)}
                  className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]">
                  <option value="">Select Working From...</option>
                  {dbWorkingFrom.map((wf: any) => (
                    <option key={wf.id || wf._id} value={wf.id || wf._id}>{wf.location || wf.name || wf.locationName}</option>
                  ))}
                </select>
              </div>

              {/* Remark */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Remark</label>
                <textarea value={editRosterRemark} onChange={e => setEditRosterRemark(e.target.value)} rows={3}
                  placeholder="Enter remarks..." className="w-full px-3 py-2.5 border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold resize-none" />
              </div>
            </div>
            <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-100">
              <button onClick={() => setShowEditRosterModal(false)} className="px-5 py-2 border border-gray-200 hover:bg-gray-50 text-xs font-semibold rounded-xl text-slate-700 transition cursor-pointer bg-white">Cancel</button>
              <button onClick={handleEditRosterSubmit} disabled={isEditRosterSubmitting}
                className="px-6 py-2 bg-[#212121] hover:bg-black text-white text-xs font-bold rounded-xl transition cursor-pointer disabled:opacity-60">
                {isEditRosterSubmitting ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Delete Roster Confirmation Modal ── */}
      {showDeleteRosterModal && deletingRoster && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm animate-in fade-in zoom-in-95 duration-200">
            <div className="p-6 text-center">
              <div className="w-14 h-14 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
                <IconTrash size={22} className="text-red-500" />
              </div>
              <h2 className="text-base font-bold text-[#212121] mb-1">Delete Roster Entry?</h2>
              <p className="text-xs text-gray-500 font-medium">
                Are you sure you want to delete this shift roster entry for
                <span className="font-bold text-[#212121]"> {deletingRoster.employee?.name || deletingRoster.employeeName || "this employee"}</span>?
                This action cannot be undone.
              </p>
            </div>
            <div className="flex items-center gap-3 px-6 pb-6">
              <button onClick={() => { setShowDeleteRosterModal(false); setDeletingRoster(null); }}
                className="flex-1 py-2.5 border border-gray-200 hover:bg-gray-50 text-xs font-bold rounded-xl text-slate-700 transition cursor-pointer bg-white">Cancel</button>
              <button onClick={handleDeleteRosterConfirm} disabled={isDeleteRosterSubmitting}
                className="flex-1 py-2.5 bg-red-500 hover:bg-red-600 text-white text-xs font-bold rounded-xl transition cursor-pointer disabled:opacity-60">
                {isDeleteRosterSubmitting ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
